<template>
  <div>
    <!-- 使用 Vant 的 van-popup 组件 -->
    <van-popup
      v-model="visible"
      :closeable="closeable"
      :close-icon="closeIcon"
      :overlay="overlay"
      :close-on-click-overlay="false"
      :style="{ width: '100%' }"
      class="custom-popup"
    >
      <div class="act-cont" style="position: relative">
        <img src="../assets/img/common/first-hdbg.png" width="100%" />
        <!-- <img class="act-cont--an" src="../assets/img/common/anniu_bg.png" />
          -->
        <p
          @click="handleRegisterAwardClick"
          class="act-cont--an"
          role="button"
          :aria-disabled="!canClaimRegisterAward() || claiming"
          :class="{ active: !canClaimRegisterAward() && token }"
        >{{ claiming ? ($lang.common_loading || 'Loading...') : $lang.Receber }}</p>
        <!-- <div class="act-cont-b">
          <p class="f-t t-c">{{ $lang.ActivityPopup_txt }}</p>
        </div>
        <div style="padding: 20px">
          <div class="d-flex-s">
            <div class="d-flex">
              <img src="../assets/img/home/home_i1.png" width="40" />
              <div class="m-l-10 l-h-20">
                <p>{{ $lang.ActivityPopup_txt2 }}</p>
                <p class="info2-color">{{ $lang.ActivityPopup_txt3 }}</p>
              </div>
            </div>
            <van-button
              size="large"
              class="custom-button"
              style="box-shadow: none; border-bottom: 0 !important"
              @click="goToRec(1)"
              :class="{
                active: receiveStatus !== 1 && token && token.length > 1
              }"
              :disabled="receiveStatus !== 1 && token && token.length > 1"
            >
              {{ $lang.Receber }}
            </van-button>
          </div>
          <p class="act-line"></p>
          <div class="d-flex-s" @click="goToRec(2)">
            <div class="d-flex">
              <img src="../assets/img/home/home_i2.png" width="40" />
              <div class="m-l-10 l-h-20">
                <p>{{ $lang.bonus_title2 }}</p>
                <p class="info2-color">{{ $lang.ActivityPopup_txt4 }}</p>
              </div>
            </div>

            <van-button size="large" class="custom-button">
              {{ $lang.ActivityPopup_txt5 }}
            </van-button>
          </div>
        </div> -->
      </div>
      <img
        @click="closeF()"
        src="../assets/img/lucky_jackpot/img_cancel.png"
        width="38"
      />
    </van-popup>
    <login v-model="showPopup2" overlay></login>
  </div>
</template>

<script>
import {
  ActivityreceiveRegisterAward,
  ActivitygetRegisterAward,
  GetCsLink
} from '@/api/common'
import { failMessage as rewardFailMessage, hasUnavailableMarker, isRewardClaimSuccessWithProof as rewardClaimSuccess, isNeedLogin, isOkResponse, responseContent } from '@/views/details/activity/rewardApi'
import { safeGetStorageItem, safeLocalStorage, safeSessionStorage, safeSetStorageItem } from '@/utils/safeStorage'
import { openExternalUrl, safeExternalUrl } from '@/views/layout/safeLayout'
import { customerServiceFailMessage, openCustomerServiceUrl } from '@/views/layout/csLink'
import { resolveH5ApkDownloadUrl } from '@/utils/runtimeConfig'

const DEFAULT_ACTIVITY_FAILURE_MESSAGE = 'Claim failed. Please try again later.'
const DEFAULT_ACTIVITY_REQUEST_FAILURE_MESSAGE = 'Request failed. Please try again later.'
const CUSTOMER_SERVICE_UNAVAILABLE_MESSAGE = 'Customer service is temporarily unavailable. Please try again later.'
const H5_APK_DOWNLOAD_UNAVAILABLE_MESSAGE = 'The download is temporarily unavailable. Please try again later.'
const GENERIC_ACTIVITY_FAILURE_MESSAGES = ['request failed', 'network error', 'networkerror', 'error']

function isGenericActivityFailureMessage(value) {
  const text = String(value == null ? '' : value).trim().toLowerCase()
  return GENERIC_ACTIVITY_FAILURE_MESSAGES.includes(text)
}

function activityFailureFallback(fallback, defaultMessage = DEFAULT_ACTIVITY_FAILURE_MESSAGE) {
  return fallback && !isGenericActivityFailureMessage(fallback) ? fallback : defaultMessage
}

function safeRewardFailMessage(res, fallback, defaultMessage = DEFAULT_ACTIVITY_FAILURE_MESSAGE) {
  const safeFallback = activityFailureFallback(fallback, defaultMessage)
  const message = rewardFailMessage(res, safeFallback)
  return isGenericActivityFailureMessage(message) ? safeFallback : message
}

function activityPayload(error) {
  if (!error || typeof error !== 'object') return error
  if (error.response && typeof error.response === 'object' && error.response.data !== undefined) return error.response.data
  return error
}

function isActivityReadUnavailable(error) {
  const payload = activityPayload(error)
  return hasUnavailableMarker(payload) || hasUnavailableMarker(responseContent(payload))
}

function showH5ApkDownloadFailure(vm) {
  if (!vm || typeof vm.$toast !== 'function') return
  vm.$toast({
    message: H5_APK_DOWNLOAD_UNAVAILABLE_MESSAGE,
    icon: 'cross'
  })
}

function openConfiguredH5ApkDownload(vm) {
  const url = resolveH5ApkDownloadUrl(safeExternalUrl)
  if (!url || !openExternalUrl(url)) {
    showH5ApkDownloadFailure(vm)
    return false
  }
  return true
}

function getLocalStorage() {
  try {
    if (typeof safeLocalStorage === 'function') return safeLocalStorage()
  } catch (e) { return null }
  return null
}

function getSessionStorage() {
  try {
    if (typeof safeSessionStorage === 'function') return safeSessionStorage()
  } catch (e) { return null }
  return null
}

export default {
  name: 'ActivityPopup',
  props: {
    // 控制弹窗显示的布尔值
    value: {
      type: Boolean,
      default: false
    },
    // 是否显示关闭按钮
    closeable: {
      type: Boolean,
      default: false
    },
    // 关闭按钮的图标
    closeIcon: {
      type: String,
      default: 'cross'
    },
    // 是否显示遮罩层
    overlay: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      // isContentVisible: false,
      showPopup2: false,
      receiveStatus: 0,
      registerAwardClaimable: false,
      claiming: false,
      rewardWritable: false,
      readOnlyQuery: false,
      readOnlyMessage: '',
      agree: false,
      agree2: false,
      visible: this.value // 内部状态
    }
  },

  watch: {
    // 监听外部传入的 value 值变化
    value(newVal) {
      this.visible = newVal
    },
    // 监听内部 visible 值变化，同步到外部
    visible(newVal) {
      this.$emit('input', newVal)
    }
  },
  mounted() {
    // 使用 Math.random() 生成 0 到 1 之间的随机数
    // this.isContentVisible = Math.random() < 0.4 // 如果随机数小于 0.3，则显示内容
    if (this.token && this.shouldOpenRegisterAwardPopup()) {
      this.ActivitygetRegisterAward()
    }
  },
  methods: {
    failMessage(res, fallback) {
      return safeRewardFailMessage(res, fallback || this.$lang.mc_claim_failed)
    },
    setRegisterAwardPopupVisible(value) {
      this.visible = value
      this.$emit('input', value)
    },
    shouldOpenRegisterAwardPopup() {
      const today = new Date().toISOString().split('T')[0]
      const sessionStorage = getSessionStorage()
      const localStorage = getLocalStorage()
      const hiddenToday = safeGetStorageItem(sessionStorage, 'neverShowToday') === today
      const hiddenForever = safeGetStorageItem(localStorage, 'neverShow') === 'true'
      return !hiddenToday && !hiddenForever
    },
    requireLogin() {
      this.visible = false
      this.showPopup2 = true
      this.$emit('closeActive')
      if (this.$bus) this.$bus.$emit('openLogin')
    },
    isReceiveSuccess(res) {
      return rewardClaimSuccess(res) && !this.hasBlockedReturnMarker(res)
    },
    markerToken(value) {
      return String(value || '').trim().toLowerCase()
    },
    isTrueFlag(value) {
      if (value === true || value === 1) return true
      return ['1', 'true', 'yes', 'on'].includes(this.markerToken(value))
    },
    isFalseFlag(value) {
      if (value === false || value === 0) return true
      return ['0', 'false', 'no', 'off'].includes(this.markerToken(value))
    },
    hasBlockedReturnMarker(payload, seen = new Set()) {
      if (!payload || typeof payload !== 'object' || seen.has(payload)) return false
      seen.add(payload)
      return Object.entries(payload).some(([key, value]) => {
        const normalizedKey = String(key || '').trim().toLowerCase()
        if (['rewardproof', 'reward_proof', 'serverproof', 'server_proof', 'affectedproof', 'affected_proof', 'writeproof', 'write_proof'].includes(normalizedKey) &&
          (value === false || value === 0 || ['0', 'false', 'no', 'off'].includes(this.markerToken(value)))) return true
        if (['readonly', 'read_only', 'readonlyreward', 'read_only_reward', 'readonlyquery', 'read_only_query', 'readonlyaction', 'read_only_action', 'readunavailable', 'read_unavailable', 'routeunavailable', 'route_unavailable', 'technicalerror', 'technical_error', 'technicalexception', 'technical_exception', 'technicalmarker', 'technical_marker', 'backendfailure', 'backend_failure', 'mock', 'mock_fallback', 'mockfallback', 'stub', 'fallback', 'fallbackused', 'fallback_used', 'dataunavailable', 'data_unavailable', 'not_supported', 'notsupported', 'not_connected', 'notconnected', 'not_implemented', 'notimplemented', 'blocked', 'backendblocked', 'backend_blocked', 'rewardbackendblocked', 'reward_backend_blocked', 'writeblocked', 'write_blocked', 'failclosed', 'fail_closed', 'falseproof', 'false_proof', 'paymentstatusunconfirmed', 'payment_status_unconfirmed', 'unconfirmed', 'unconfirmedsuccess', 'unconfirmed_success', 'unimplemented'].includes(normalizedKey) &&
          (value === true || value === 1 || ['1', 'true', 'yes', 'on', 'mock', 'stub', 'fallback', 'fallback_used', 'data_unavailable', 'read_only', 'readonly', 'read_only_reward', 'readonlyreward', 'read_only_query', 'readonlyquery', 'read_only_action', 'readonlyaction', 'read_unavailable', 'readunavailable', 'route_unavailable', 'routeunavailable', 'technical_error', 'technicalerror', 'technical_exception', 'technicalexception', 'technical_marker', 'technicalmarker', 'backend_failure', 'backendfailure', 'not_supported', 'notsupported', 'not_connected', 'notconnected', 'not_implemented', 'notimplemented', 'unimplemented', 'blocked', 'backendblocked', 'backend_blocked', 'rewardbackendblocked', 'reward_backend_blocked', 'writeblocked', 'write_blocked', 'failclosed', 'fail_closed', 'fail closed', 'falseproof', 'false_proof', 'false proof', 'paymentstatusunconfirmed', 'payment_status_unconfirmed', 'payment status unconfirmed', 'unconfirmed', 'unconfirmedsuccess', 'unconfirmed_success'].includes(this.markerToken(value)))) {
          return true
        }
        if (['message', 'msg', 'reason'].includes(normalizedKey)) {
          const text = this.markerToken(value)
          if (text.includes('未接入') || text.includes('mock') || text.includes('stub') || text.includes('fallback') || text.includes('只读') || text.includes('阻止假成功') || text.includes('readonlyaction') || text.includes('read only action') || text.includes('read_only_action') || text.includes('writeblocked') || text.includes('write blocked') || text.includes('write_blocked') || text.includes('backendblocked') || text.includes('backend blocked') || text.includes('backend_blocked') || text.includes('backendfailure') || text.includes('backend failure') || text.includes('backend_failure') || text.includes('rewardbackendblocked') || text.includes('reward backend blocked') || text.includes('reward_backend_blocked') || text.includes('failclosed') || text.includes('fail closed') || text.includes('fail_closed') || text.includes('falseproof') || text.includes('false proof') || text.includes('false_proof') || text.includes('paymentstatusunconfirmed') || text.includes('payment status unconfirmed') || text.includes('payment_status_unconfirmed') || text.includes('unconfirmed') || text.includes('not_connected') || text.includes('not connected') || text.includes('not_supported') || text.includes('not supported') || text.includes('not_implemented') || text.includes('not implemented') || text.includes('routeunavailable') || text.includes('route unavailable') || text.includes('route_unavailable') || text.includes('readunavailable') || text.includes('read unavailable') || text.includes('read_unavailable') || text.includes('technicalerror') || text.includes('technical error') || text.includes('technical_error') || text.includes('technicalmarker') || text.includes('technical marker') || text.includes('technical_marker') || text.includes('technicalexception') || text.includes('technical exception') || text.includes('technical_exception') || text.includes('技术错误') || text.includes('技术异常') || text.includes('unimplemented')) return true
        }
        return value && typeof value === 'object' && this.hasBlockedReturnMarker(value, seen)
      })
    },
    isRegisterAwardClaimableContent(content, payload) {
      const blocked = this.hasBlockedReturnMarker(payload) || this.hasBlockedReturnMarker(content)
      const explicitClaimable = this.isTrueFlag(content.claimable) || this.isTrueFlag(content.canReceive)
      const writable = content.rewardWritable === undefined ? true : this.isTrueFlag(content.rewardWritable)
      return !blocked && writable && explicitClaimable && Number(content.receiveStatus) === 1
    },
    canClaimRegisterAward() {
      return this.registerAwardClaimable && this.rewardWritable && !this.readOnlyQuery && this.receiveStatus === 1
    },
    showRegisterAwardUnavailable() {
      this.$toast({
        message: this.readOnlyMessage || activityFailureFallback(this.$lang.mc_claim_failed),
        icon: 'warning-o'
      })
    },
    closeF() {
      const sessionStorage = getSessionStorage()
      const localStorage = getLocalStorage()
      if (this.agree) {
        // 今日不显示
        const today = new Date().toISOString().split('T')[0]
        safeSetStorageItem(sessionStorage, 'neverShowToday', today)
      }
      if (this.agree2) {
        // 永久不显示
        safeSetStorageItem(localStorage, 'neverShow', 'true')
      }
      this.visible = false
      this.$emit('closeActive2')
    },
    goToRec(i) {
      if (i === 1) {
        this.handleRegisterAwardClick()
      }
      if (i === 2) {
        this.$jumpTo('/activityFistRecharge')
        this.visible = false
      }
      if (i === 3) {
        this.$jumpTo('/vipSignIn')
        this.visible = false
      }
    },
    handleRegisterAwardClick() {
      if (this.claiming) return
      if (!this.token) {
        this.requireLogin()
        return
      }
      if (!this.canClaimRegisterAward()) {
        this.showRegisterAwardUnavailable()
        return
      }
      this.ActivityreceiveRegisterAward()
    },
    async ActivitygetRegisterAward() {
      try {
        const data = await ActivitygetRegisterAward()
        const content = responseContent(data)
        const blocked = this.hasBlockedReturnMarker(data) || this.hasBlockedReturnMarker(content)
        if (isNeedLogin(data)) {
          this.requireLogin()
        } else if (isOkResponse(data) && !blocked) {
          this.receiveStatus = Number(content.receiveStatus) || 0
          this.rewardWritable = content.rewardWritable !== false && !this.isFalseFlag(content.rewardWritable) && !blocked
          this.readOnlyQuery = content.readOnlyQuery === true || this.isTrueFlag(content.readOnlyQuery) || blocked
          this.readOnlyMessage = content.readOnlyMessage || content.rewardMessage || ''
          this.registerAwardClaimable = this.isRegisterAwardClaimableContent(content, data)
          this.setRegisterAwardPopupVisible(this.registerAwardClaimable)
        } else {
          this.receiveStatus = 0
          this.rewardWritable = false
          this.readOnlyQuery = blocked
          this.readOnlyMessage = content.readOnlyMessage || content.rewardMessage || content.message || ''
          this.registerAwardClaimable = false
          this.setRegisterAwardPopupVisible(false)
          if (isActivityReadUnavailable(data)) return
          this.$toast({
            message: this.failMessage(data, this.$lang.mc_claim_failed),
            icon: 'cross'
          })
        }
      } catch (error) {
        this.registerAwardClaimable = false
        this.setRegisterAwardPopupVisible(false)
        if (isActivityReadUnavailable(error)) return
        this.$toast({
          message: this.failMessage(error, DEFAULT_ACTIVITY_REQUEST_FAILURE_MESSAGE),
          icon: 'cross'
        })
      }
    },
    async ActivityreceiveRegisterAward() {
      if (this.claiming) return
      if (!this.canClaimRegisterAward()) {
        this.showRegisterAwardUnavailable()
        return
      }
      this.claiming = true
      try {
        const data = await ActivityreceiveRegisterAward()
        if (isNeedLogin(data)) {
          this.requireLogin()
        } else if (this.isReceiveSuccess(data)) {
          this.ActivitygetRegisterAward()
          this.$toast({
            message: this.$lang.bonus_txt16,
            icon: 'success'
          })
          if (this.$bus) this.$bus.$emit('refsh-amount')
        } else {
          this.$toast({
            message: this.failMessage(data, this.$lang.mc_claim_failed),
            icon: 'cross'
          })
        }
      } catch (error) {
        this.$toast({
          message: this.failMessage(error, DEFAULT_ACTIVITY_REQUEST_FAILURE_MESSAGE),
          icon: 'cross'
        })
      } finally {
        this.claiming = false
      }
    },
    goTod() {
      this.$jumpTo('/firstRegister', {}, { replace: true })
    },
    async openPopupCustomerService(type = 'telegram') {
      try {
        const data = await GetCsLink()
        const opened = type === 'telegram'
          ? openCustomerServiceUrl(data, 'telegram')
          : openCustomerServiceUrl(data, type)
        if (opened) return
      } catch (e) {
        if (this.$toast) {
          this.$toast({
            message: customerServiceFailMessage(e, CUSTOMER_SERVICE_UNAVAILABLE_MESSAGE),
            icon: 'cross'
          })
        }
        return
      }
      if (this.$toast) {
        this.$toast({
          message: CUSTOMER_SERVICE_UNAVAILABLE_MESSAGE,
          icon: 'cross'
        })
      }
    },
    goTo(i) {
      if (i === 1) {
        this.openPopupCustomerService()
      } else if (i === 2) {
        this.openPopupCustomerService('whatsapp')
      } else {
        openConfiguredH5ApkDownload(this)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.activity-bg {
  background: url(../assets/img/home/activity-bg.png);
  width: 100%;
  height: 455px;
  background-size: 100% 100%;
  position: relative;
  .activity-bg--i {
    position: absolute;
    opacity: 0.8;
    height: 70px;
    width: 88%;
    top: 360px;
    margin: 0 auto;
    left: 0;
    right: 0;
    display: flex;
    justify-content: space-between;
    p {
      width: 28%;
    }
  }
}
.custom-popup {
  background: transparent;
  text-align: center;
  z-index: 2003 !important;
  .van-overlay {
    z-index: 2000 !important;
  }
}
.act-cont-b {
  background: url(../assets/img/home/home_acBg.png) no-repeat;
  background-size: 100% 100%;
  height: 230px;
  padding-top: 15px;
  font-size: var(--vk-fs-2xl);
  text-shadow: -1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000,
    1px 1px 0 #000; /* 四个方向的阴影，形成描边效果 */
}
.act-cont {
  // background: #123454;
  background: transparent;

  // padding: 20px 15px 15px 15px;
  text-align: left;
  margin: 0 auto;
  // width: 93%;
  border-radius: 15px;
  ::v-deep .van-checkbox__icon .van-icon {
    border: none;
  }
  ::v-deep .van-checkbox__icon--checked .van-icon {
    background-color: var(--vk-brand) !important;
  }
}

.custom-button {
  width: 75px;
  height: 35px;
  border-radius: 10px;
  font-size: var(--vk-fs-base);
}
.active {
  // box-shadow: 0 4px 1px #4a4a4a !important; /* 阴影效果 */
  background: #9b9b9b !important;
  // border-bottom: 0px solid #494949 !important;
}
.act-line {
  height: 2px;
  background: linear-gradient(to right, #204062, #536c94, #204062);
  margin: 20px 0;
}
.act-cont--an {
  position: absolute;
  width: 29%;
  margin: 0 auto;
  left: 0;
  right: 0;
  top: 85%;
  animation: breathe 2s ease-in-out infinite;
  background: var(--vk-grad); /* 领取 CTA=火焰橙渐变(铁律①,原 navy #1d567d) */
  border-radius: 10px;
  color: var(--vk-bg); /* CTA 深字(WCAG AA) */
  font-size: var(--vk-fs-lg);
  padding: 10px 0;
  text-align: center;
}
/* 呼吸动画 */
@keyframes breathe {
  0% {
    transform: scale(1);
    // box-shadow: 0 0 0 0 rgba(14, 190, 255, 0.7);
  }
  50% {
    transform: scale(1.2);
    // box-shadow: 0 0 0 10px rgba(14, 190, 255, 0);
  }
  100% {
    transform: scale(1);
    // box-shadow: 0 0 0 0 rgba(14, 190, 255, 0);
  }
}
</style>
